import LoaderCover from './LoaderCover';

export default LoaderCover;
